import { FREE_TOOLS } from "@/config/freeTools";

export function toolPath(slug: string): string {
  return `/${slug}`;
}

export function isPeeqdToolSlug(slug: string): boolean {
  return FREE_TOOLS.some((tool) => tool.slug === slug);
}
